import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { UserService } from 'src/app/core/service/user.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResizedEvent } from 'src/app/shared/resize-event/resized-event';
import { SettingService } from '../service/setting.service';
import { SettingNavService } from './setting-nav.service';
import { groupBy } from 'lodash';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { LocalStorageService } from 'ngx-webstorage';
@Component({
  selector: 'app-setting-nav',
  templateUrl: './setting-nav.component.html',
  styleUrls: ['./setting-nav.component.scss']
})
export class SettingNavComponent implements OnInit
{
  public columns = 3;
  public settingItems: Array<{ titleKey: string; descriptionKey: string; permissions: string[]; route: string }> = [];
  public tabs: Map<string, Array<{ titleKey: string; descriptionKey: string; permissions: string[]; route: string }>>;
  public patientLabel = {};
  public selectedTab = 0;

  constructor(
    private settingService: SettingService,
    private settingNavService: SettingNavService,
    private storageService: LocalStorageService,
    private router: Router,
    private userService: UserService,
    private authenticationService: AuthenticationService)
  {
  }

  public ngOnInit(): void
  {
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        const addUpdateCommunityResourcesEnabled = sessionSetting.communityEnabled && sessionSetting.addUpdateCommunityResourcesRoles !== '' &&
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.addUpdateCommunityResourcesRoles);

        const providersEnabled = sessionSetting.providersRoles !== '' &&
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.providersRoles);

        this.settingItems = this.settingNavService.getMenuItems(sessionSetting.communityEnabled, sessionSetting.patientLabel,
          addUpdateCommunityResourcesEnabled, providersEnabled, sessionSetting, this.authenticationService.currentUser.role);

        this.patientLabel = { patientLabel: sessionSetting.patientLabel };

        // Create tabs Map
        setTimeout(() =>
        {
          const tabGroups = groupBy(this.settingItems, 'groupKey');
          this.tabs = new Map();
          Object.keys(tabGroups).forEach((value) =>
          {
            this.tabs.set(value, tabGroups[value]);
          });

          // Select tab automatically if already store in the local storage.
          const tabIndex = this.storageService.retrieve('setting-nav-selected-tab');
          if (tabIndex !== null && tabIndex !== undefined && tabIndex >= 0)
          {
            this.selectedTab = tabIndex;
          }
        });
      }
    });
  }

  /**
   * Navigate to the selected setting
   *
   * @param url Url to navigate to.
   */
  public navigate(url: string): void
  {
    this.router.navigate([`${url}`]);
  }

  /**
   * Reset kendo-tilelayout columns on resize.
   *
   * @param e ResizedEvent
   */
  public onResized(e: ResizedEvent): void
  {
    if (e.newWidth <= 1000)
    {
      this.columns = 2;
    }
    else if (e.newWidth <= 1200)
    {
      this.columns = 3;
    }
    else
    {
      this.columns = 4;
    }
  }

  public onTabSelect(e: SelectEvent): void
  {
    this.selectedTab = e.index;
    this.storageService.store('setting-nav-selected-tab', this.selectedTab);
  }
}
